export const TIMEBLOCK_TYPE_IDS = {
  NORMAL: "494118c3-8cf7-4c46-9933-ab7a481148ec",
  SPECIAL: "763C28F5-49AD-442B-B3EE-94BDCC59AA2C",
  SEASONAL: "0480ee25-6446-4e5a-ab93-e0e28772df97",
  SEASONAL_CAMPAIGN: "67a43f72-d56b-411e-bd1d-776e16c944e0",
} as const;
